module.exports = __webpack_public_path__ + "assets/c6e5a2e2432e939a26f2eba882300a53.mp3";